/* __next_internal_client_entry_do_not_use__ sizes,MediaQueryProvider,useBreakpointsContext auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, memo, useContext, useMemo } from "react";
import { useMedia } from "__barrel_optimize__?names=useMedia!=!react-use";
export const sizes = {
    xxlarge: 1174,
    xlarge: 1104,
    large: 920,
    medium: 700,
    small: 560,
    zero: 0
};
const defaultValue = {
    isAboveSmallScreen: true,
    isAboveMediumScreen: true,
    isAboveLargeScreen: false,
    isAboveXLScreen: false,
    isAboveXXLScreen: false
};
const MediaQueryContext = /*#__PURE__*/ createContext(defaultValue);
const mediaQueries = {
    isAboveSmall: "(min-width: ".concat(sizes.small, "px)"),
    isAboveMedium: "(min-width: ".concat(sizes.medium, "px)"),
    isAboveLarge: "(min-width: ".concat(sizes.large, "px)"),
    isAboveXL: "(min-width: ".concat(sizes.xlarge, "px)"),
    isAboveXXL: "(min-width: ".concat(sizes.xxlarge, "px)")
};
export const MediaQueryProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const isAboveSmallScreen = useMedia(mediaQueries.isAboveSmall, defaultValue.isAboveSmallScreen);
    const isAboveMediumScreen = useMedia(mediaQueries.isAboveMedium, defaultValue.isAboveMediumScreen);
    const isAboveLargeScreen = useMedia(mediaQueries.isAboveLarge, defaultValue.isAboveLargeScreen);
    const isAboveXLScreen = useMedia(mediaQueries.isAboveXL, defaultValue.isAboveXLScreen);
    const isAboveXXLScreen = useMedia(mediaQueries.isAboveXXL, defaultValue.isAboveXXLScreen);
    const value = useMemo(()=>({
            isAboveSmallScreen,
            isAboveMediumScreen,
            isAboveLargeScreen,
            isAboveXLScreen,
            isAboveXXLScreen
        }), [
        isAboveSmallScreen,
        isAboveMediumScreen,
        isAboveLargeScreen,
        isAboveXLScreen,
        isAboveXXLScreen
    ]);
    return /*#__PURE__*/ _jsx(MediaQueryContext.Provider, {
        value: value,
        children: children
    });
});
MediaQueryProvider.displayName = "MediaQueryProvider";
export function useBreakpointsContext() {
    const context = useContext(MediaQueryContext);
    if (context === defaultValue) {
        throw "useBreakpointsContext used outside of MediaQueryProvider";
    }
    return context;
}
